import React from 'react'
import DutiesOverview from './duties/index.jsx'
import EmployeeSods from './duties/employees/index.jsx'
import EmployeeSod from './duties/employees/show.jsx'
import Conflicts from './duties/conflicts/index.jsx'
import Conflict from './duties/conflicts/show.jsx'
import Permissions from 'duties/permissions/index.jsx'
import Permission from 'duties/permissions/show.jsx'
import Roles from './duties/roles/index.jsx'
import Role from './duties/roles/show.jsx'
import BusinessRules from './duties/business_rules/index.jsx'
import BusinessRule from './duties/business_rules/show.jsx'
import WorkflowProcesses from './duties/workflow-processes/index.jsx'
import WorkflowProcessShow from './duties/workflow-processes/show.jsx'
import AuditLogs from './duties/audit_logs/index.jsx'
import Issues from './duties/issues/index.jsx'
import IssuesShow from './duties/issues/show.jsx'
import Exports from './duties/exports/index.jsx'
import DataAccesses from './duties/data-accesses/index.jsx'
import DataAccess from './duties/data-accesses/show.jsx'
import AccessManagementSettings from './settings/access-management'
import { Route, Routes, Navigate } from 'react-router-dom'

function AuthenticatedAccessManagement() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate replace to="/duties" />} />
        <Route path="/conflicts" exact={true} element={<Conflicts />} />
        <Route path="/conflicts/:id" element={<Conflict />} />
        <Route path="/duties" exact={true} element={<DutiesOverview />} />
        <Route path="/users" exact={true} element={<EmployeeSods />} />
        <Route path="/users/:id" element={<EmployeeSod />} />
        <Route path="/roles" exact={true} element={<Roles />} />
        <Route path="/roles/:id" element={<Role />} />
        <Route path="/permissions" exact={true} element={<Permissions />} />
        <Route path="/permissions/:id" element={<Permission />} />
        <Route
          path="/business-rules"
          exact={true}
          element={<BusinessRules />}
        />
        <Route path="/business-rules/:id" element={<BusinessRule />} />
        <Route
          path="/processes"
          element={<WorkflowProcesses />}
          exact={true}
        />
        <Route
          path="/processes/:id"
          element={<WorkflowProcessShow />}
        />

        <Route path="/issues" exact={true} element={<Issues />} />
        <Route path="/issues/:id" element={<IssuesShow />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
        <Route path="/access-management-exports" element={<Exports />} />
        <Route path="/sod-exports" element={<Navigate replace to="/access-management-exports" />} />
        <Route path="/data-access" element={<DataAccesses />} />
        <Route path="/data-access/:id" element={<DataAccess />} />
        <Route path="/settings" element={<AccessManagementSettings />} />
      </Routes>
    </>
  )
}

export default AuthenticatedAccessManagement
